import React, { Component } from 'react';
import '../../../styles/variables.css';
import './BackendVacancies.css';
import BackendCard from '../components/BackendCard';
import { Link } from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import database from '../../../firebase/firebase';
import {NotificationContainer} from 'react-notifications';
import {ShowNotification} from '../../../components/HandleNotifications';
import {createNew, removeJobs} from '../../../actions/_vacancies_actions';

class BackendVacancies extends Component {
    state = {
        jobs: [],
        showModal: false,
        triggered: false,
        edit: {},
        pageNumber: 1
    }

    triggerDelete = () => {
        this.setState(prevState => ({
            triggered: !prevState.triggered
        }));
    };

    componentDidMount(){
        if(this.props.companyData.onCreate){
            this.props.history.push(`/company/mycompany`)
        }
    }

    seeApplicants = (id, owner) =>{
        this.props.history.push(`vacancies/applicants/${id}/${owner}`)
    }

    render(){
        return(
            <div className="b-container">
                <div className="b-actions">
                    <button onClick={this.triggerDelete} className="button__unsafe">
                        {this.state.triggered === true ? "Cancelar" : "Eliminar Vacante"}
                    </button>
                    <Link to="/company/vacancies/create" className="button__submit__" type="button">Crear Vacante</Link>
                </div>
                <div className="b-cards-container">
                    {this.props.jobs.map((job) => {
                        if(job.Status){
                            return <BackendCard
                                    key={job.jobID}
                                    {...job}
                                    seeApplicants={this.seeApplicants}
                                    triggered={this.state.triggered}
                                    name={this.props.companyData.companyName.toUpperCase()}
                                    onRemove={this.onRemove}
                                    edit={this.edit}
                                />
                        }
                    })}
                </div>
                <NotificationContainer />
            </div>
        )
    }
    
    onRemove = (id) => {
        const newValues = this.props.jobs.filter((job) => id.id === job.jobID)
        newValues[0].Status = false;
        database
            .collection(`companies/${this.props.id}/jobs`)
            .doc(id.id)
            .update({Status: false})
            .then(()=>{
                return database.collection('vacancies').doc(id.id).delete();
            })
            .then(() => {
                this.props.updateJobs(this.props.jobs)
                ShowNotification('error', 'Listo',`Se borro la vacante exitosamente`)
            });
    };

    edit = (id) => {     
        this.props.history.push(`${this.props.location.pathname}/edit-job/${id}`);           
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
}
const mapStateToProps = (state) => ({
    companyData: state.company,
    id: state.auth.uid,
    jobs: state.vacancies
})

const mapDispatchToProps = (dispatch) => ({
    createNew: (payload, isNew) => dispatch(createNew(payload, isNew)),
    updateJobs: (newVals) => dispatch(removeJobs(newVals))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BackendVacancies));